import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="overline">Caricamento…</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    return children;
}
